import React, {useEffect, useState} from 'react'
import * as THREE from "three"
import { useSelector, useDispatch } from 'react-redux'
import { handleLunghezza, handleLarghezza} from "../../Redux/UIMenus/uiMainMenuSlice";
import { E_ConfOmbrelloniContrapposti, E_MainLato, E_OmbrelloniContrappostiState } from '../Utils/enumerations';

// Mostra la dimensione della pavimentazione sulla griglia quando manca la pedana
export default function BasePiattaforma() {
    const lunghezza = useSelector(state => state.uiMainMenu.lunghezza);
    const larghezza = useSelector(state => state.uiMainMenu.larghezza);    
    const darkTheme = useSelector(state => state.uiMenuState.darkTheme);
    const hasOmbrelloniContrapposti = useSelector(state => state.uiOmbrelloniMenu.ombrelloniContrapposti);
    const configurazioneOmbrelloniContrapposti = useSelector(state => state.uiOmbrelloniMenu.confOmbrelloniContrapposti);
    const dataOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.dataOmbrelloni);
    const latoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.latoOmbrelloni);

    // Salvataggio misure precedenti 
    const [canUnblockDimensions, setCanUnblockDimensions] = useState(false);
    const [saveLunghezza, setSaveLunghezza] = useState(lunghezza);
    const [saveLarghezza, setSaveLarghezza] = useState(lunghezza);

    const dispatch = useDispatch();
    
    const points = [];
    points.push(new THREE.Vector3(-lunghezza/2, 0, larghezza/2));
    points.push(new THREE.Vector3(-lunghezza/2, 0, -larghezza/2));
    points.push(new THREE.Vector3(lunghezza/2, 0, -larghezza/2));
    points.push(new THREE.Vector3(lunghezza/2, 0, larghezza/2));
    points.push(new THREE.Vector3(-lunghezza/2, 0, larghezza/2));   
    
    const lineGeometry = new THREE.BufferGeometry().setFromPoints(points);    

    // Blocca le dimensioni per gli ombrelloni contrapposti
    const blockDimensions = () => {
        if (dataOmbrelloni.length > 0) {            
            if (hasOmbrelloniContrapposti) {              
                if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString() || latoOmbrelloni.toString() === E_MainLato.Lato3.toString()) {
                    setSaveLunghezza(lunghezza);
                    setSaveLarghezza(larghezza);
                    dispatch(handleLunghezza(dataOmbrelloni[0].secondaryDimension * 2));               
                }
                else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString() || latoOmbrelloni.toString() === E_MainLato.Lato4.toString()) {            
                    setSaveLarghezza(larghezza);
                    setSaveLunghezza(lunghezza);
                    dispatch(handleLarghezza(dataOmbrelloni[0].secondaryDimension * 2));
                }       
            }  
        }
        setCanUnblockDimensions(true);            
    }

    // Blocca le dimensioni per gli ombrelloni contrapposti
    useEffect(() => {    
        // Se ha gli ombrelloni contrapposti blocca le dimensioni
        if (hasOmbrelloniContrapposti) {
            blockDimensions(); 
        }
        if (canUnblockDimensions) {
            dispatch(handleLunghezza(saveLunghezza));   
            dispatch(handleLarghezza(saveLarghezza));
            setCanUnblockDimensions(false);    
        }  
    }, [hasOmbrelloniContrapposti, configurazioneOmbrelloniContrapposti]);

    return (
        <group>
            <line geometry={lineGeometry}>
                <bufferGeometry attach="lineGeometry" setFromPoints={points} />
                <lineBasicMaterial attach="material" color={darkTheme ? "#909090" : '#90ee90'} linewidth={10} linecap={'round'} linejoin={'round'} />
            </line>           
        </group>
    )
}
